"use strict";

const ADMIN_TYPE = 'adminRole';
const USER_TYPE = 'userRole';
const AuthorizedAdminRole = require('bunsen/models/identity/AuthorizedAdminRole');
const AuthorizedUserRole = require('bunsen/models/identity/AuthorizedUserRole');

/**
 * An AuthorizedRole model gives the client information about what roles are permitted to take an action.
 * The "Role" specified is not the same as a "Role" in our system (where a role is a collection of permissions that
 * can be assigned to any internal user).
 * The role can be a collection of required permissions (which may be independent of internal user Roles) or it can
 * check against a user's ID.
 * ** NOTE - there are 2 authorized Role models, this parent model just uses the constructor / apiType property to
 * correctly identify the model type.
 *
 * AuthorizedRoles are used in the available actions
 * @type {Function}
 */
const AuthorizedRole = function (data, options) {
    const type = data.apiType || USER_TYPE;
    switch (type) {
        case USER_TYPE :
            return new AuthorizedUserRole(data, options);
        case ADMIN_TYPE :
            return new AuthorizedAdminRole(data, options);
    }
};

AuthorizedRole.apiTypes = {
    admin: ADMIN_TYPE,
    user: USER_TYPE
};

module.exports = AuthorizedRole;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/AuthorizedRole.es.js